export const PAGE_TEXT = {
  PICS: 'Personal Information Collection Statement',
  PPS: 'Privacy Policy Statement',
  NAEEA: 'Notice for Applicants from the European Economic Area',
  PROTECTION_LAW: 'Personal Information Protection Law (PIPL) of PRC',
  SUPPORT:
    'If you find any aspect of this website inaccessible, please contact us at ',
  EMAIL: 'gs.it@polyu.edu.hk',
  COPYRIGHT: 'Copyright ©',
  HKPU: 'The Hong Kong Polytechnic University. All rights reserved.',
};
